/*
 * Module for the Service Purhase Payment Index view
*/

rs.module("content/participant/member/servicepurchase/paymentsindex",

    [ "common/select-helper" ],

    function (selectHelper) {

        //
        // Initialize
        //
        function initialize(jsSelectors, ajaxUrl, columnIds, noneCodeValue, currentDateString) {
            var adjustBalanceForm = $.js(jsSelectors.adjustBalanceForm);
            var adjustBalanceModal = adjustBalanceForm.js(jsSelectors.adjustBalanceModal);
            var spcPaymentKey = adjustBalanceModal.js(jsSelectors.spcPaymentKey);
            var spcContractKey = adjustBalanceModal.js(jsSelectors.spcContractKey);
            var accountPartyKey = adjustBalanceModal.js(jsSelectors.accountPartyKey);
            var organizationRefNumber = adjustBalanceModal.js(jsSelectors.organizationRefNumber);
            var paymentType = adjustBalanceModal.js(jsSelectors.paymentType);
            var calculateInterestDate = adjustBalanceModal.js(jsSelectors.calculateInterestDate);
            var interestAmount = adjustBalanceModal.js(jsSelectors.interestAmount);
            var principalAmount = adjustBalanceModal.js(jsSelectors.principalAmount);
            var paymentAmount = adjustBalanceModal.js(jsSelectors.paymentAmount);
            var paymentStatus = adjustBalanceModal.js(jsSelectors.paymentStatus);
            var dailyPaymentOrder = adjustBalanceModal.js(jsSelectors.dailyPaymentOrder);
            var updateToken = adjustBalanceModal.js(jsSelectors.updateToken);
            var currentBalanceAmount = adjustBalanceModal.js(jsSelectors.currentBalanceAmount);
            var paymentDate = adjustBalanceModal.js(jsSelectors.paymentDate);
            var spcPaymentAction = adjustBalanceModal.js(jsSelectors.spcPaymentAction);
            var spcPaymentActionSelectHelper = selectHelper.getHelper(spcPaymentAction);
            var adjustBalanceSpinner = adjustBalanceModal.js(jsSelectors.adjustBalanceSpinner);

            $(document).onjs('click', jsSelectors.adjustBalanceAddLink, function () {
                clearErrors();
                adjustBalanceModal.modal('show');
                currentBalanceAmount.val('$0.00');
                paymentDate.val(currentDateString);
                spcPaymentActionSelectHelper.setValue(noneCodeValue);
            });

            $(document).onjs('click', jsSelectors.adjustBalanceEditLink, function () {
                clearErrors();
                adjustBalanceModal.modal('show');

                $.get(
                    ajaxUrl,
                    {
                        spcPaymentKey: $(this)[0].dataset[columnIds.spcPaymentKey.toLowerCase()],
                        spcContractKey: $(this)[0].dataset[columnIds.spcContractKey.toLowerCase()]
                    },

                    function (data) {
                        spcContractKey.val(data[columnIds.spcContractKey]);
                        spcPaymentKey.val(data[columnIds.spcPaymentKey]);
                        accountPartyKey.val(data[columnIds.accountPartyKey]);
                        organizationRefNumber.val(data[columnIds.organizationRefNumber]);
                        paymentType.val(data[columnIds.paymentType]);
                        calculateInterestDate.val(data[columnIds.calculateInterestDate] ? new Date(data[columnIds.calculateInterestDate]).toISODateString() : null);
                        interestAmount.val(data[columnIds.interestAmount]);
                        principalAmount.val(data[columnIds.principalAmount]);
                        paymentAmount.val(data[columnIds.paymentAmount]);
                        paymentStatus.val(data[columnIds.paymentStatus]);
                        dailyPaymentOrder.val(data[columnIds.dailyPaymentOrder]);
                        updateToken.val(data[columnIds.updateToken]);
                        currentBalanceAmount.val(data[columnIds.currentBalanceAmount]);
                        paymentDate.val(data[columnIds.paymentDate] ? new Date(data[columnIds.paymentDate]).toISODateString() : null);
                    }
                );
            });

            // clear the errors in the adjust balance modal
            function clearErrors() {
                currentBalanceAmount.clearErrors();
                paymentDate.clearErrors();
                spcPaymentAction.clearErrors();
            }

            $.js(jsSelectors.adjustBalanceForm).submit(function (e) {
                var validator = $(this).validate();
                var isValid = validator.form();

                if (isValid) {
                    adjustBalanceSpinner.show();
                }
                else {
                    e.preventDefault();
                }

            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);